import { render, staticRenderFns } from "./SalesByCustomer.vue?vue&type=template&id=ce1b110c"
import script from "./SalesByCustomer.vue?vue&type=script&lang=js"
export * from "./SalesByCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports